<template>
  <div class="dashboard-form-create">
    <div class="md-layout md-alignment-top-center">
      <div class="md-layout-item md-size-50 ">
          <form-create-form></form-create-form>
      </div>
    </div>
  </div>
</template>

<script>
import FormCreateForm from '../forms/FormCreateForm'

export default {
  name: 'DashboardFormCreate',
  components: {
    FormCreateForm
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/DashboardFormCreate.vue